import React from 'react';
import { cn } from '../../lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, label, error, helperText, id, ...props }, ref) => {
    const generatedId = React.useId();
    const inputId = id || `input-${generatedId}`;

    return (
      <div className="space-y-1 mb-0">
        {label && (
          <label
            htmlFor={inputId}
            className="text-black text-sm font-medium text-body-form-label"
          >
            {label}
          </label>
        )}
        <input
          type={type}
          id={inputId}
          className={cn(
            'flex w-full text-sm bg-white px-2 py-2.5 text-black placeholder:text-xs placeholder:text-[#989797] focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            'rounded-md shadow-none border',
            error ,
            className
          )}
          ref={ref}
          {...props}
        />
        {error && (
          <p
            className="text-destructive text-xs"
          >
            {error}
          </p>
        )}
        {helperText && !error && (
          <p
            className="text-[#64748B] text-xs"
          >
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export { Input };